module.exports = __webpack_public_path__ + "static/media/08-slider.4bd03868.png";